// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/v1.223.0/js/" + "flags" + "." + "603977fefce4745bb24e" + ".js";
};